import { Container, Flex, Box } from 'theme-ui';

import { Header } from '../Header';
import { Icons } from './Icons';
import { Options } from './Options';
import { SizeOptions } from './SizeOptions';
import { ColorOptions } from './ColorOptions';
import { AddToCart } from './AddToCart';
import { Personalize } from './Personalize';
import { Metadata } from './Metadata';
import { themed } from './Details.theme';
import { Upsells } from './Upsells';
import { BuyWithPrime } from '../BuyWithPrime';

export const Details = themed(
  ({
    theme,
    product,
    selectedVariant,
    currentProduct,
    titles,
    productUpsells,
    rebuyProducts,
    videoWise,
  }) => {
    return (
      <Container data-comp={Details.displayName} sx={theme.wrapper}>
        <Box data-comp="StickyContainer" sx={theme.sticky}>
          <Flex sx={theme.sticky.wrapper}>
            <Box sx={{ display: ['none', null, 'block'] }}>
              <Header
                selectedVariant={selectedVariant}
                currentProduct={currentProduct}
                titles={titles}
              />
            </Box>

            <Flex sx={theme.ctas}>
              {/* Sizes etc.. */}
              {product?.optionsMap && selectedVariant ? (
                <Options
                  options={product?.optionsMap}
                  handle={selectedVariant?.product?.handle}
                  image={selectedVariant?.image?.originalSrc}
                />
              ) : null}

              <SizeOptions product={currentProduct} />

              <ColorOptions product={product} />

              <AddToCart
                product={currentProduct}
                selectedVariant={selectedVariant}
                rebuyProducts={rebuyProducts}
              />

              <Personalize product={currentProduct} />

              <BuyWithPrime sku={selectedVariant?.sku} />

              {!!videoWise?.length && <div className="w-full">{videoWise}</div>}

              {productUpsells?.length ? (
                <Box sx={{ width: '100%' }}>{productUpsells[0]}</Box>
              ) : (
                <Upsells selectedVariant={selectedVariant} />
              )}

              <Icons product={currentProduct} />

              {currentProduct && (
                <Metadata
                  product={currentProduct}
                  selectedVariant={selectedVariant}
                />
              )}
            </Flex>
          </Flex>
        </Box>
      </Container>
    );
  }
);

Details.displayName = 'ProductDetails';
